import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: (p) => p.spacing(1),
  mt: (p) => p.spacing(1),
  padding: (p) => p.spacing(0, 1),
};

export const leftBox: SxStyle = {
  flex: 1,
};

export const rightBox: SxStyle = {};

const videoBase: SxStyle = {
  borderRadius: (p) => p.spacing(1),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  padding: (p) => p.spacing(0, 2),
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
};

export const video: SxStyleFunc<boolean> = (isCompany) => ({
  ...videoBase,
  ...(!isCompany && {
    opacity: 0.5,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  }),
});

export const iconBox: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  padding: (p) => p.spacing(0.5),
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[400],
  width: (p) => p.spacing(3),
  height: (p) => p.spacing(3),
};

export const loadingSpinner: SxStyle = {
  color: (p) => p.palette.grey[400],
};

export const placeholderIcon: SxStyle = {
  color: (p) => p.palette.grey[500],
};

export const videoLink: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
